module.exports = __webpack_public_path__ + "img/work-hard-on-desktop-penguin.bf354d81.svg";